import { combineReducers } from "redux";
import Prices from "./Prices/Prices.reducer";
import GlobalStats from "./GlobalStats/GlobalStats.reducer";
import FoundationAddresses from "./FoundationAddresses/FoundationAddresses.reducer";
import TokenTransfers from "./TokenTransfers/TokenTransfers.reducer";
import TokenTransactions from "./TokenTransactions/TokenTransactions.reducer";
import AccountTransactions from "./AccountTransactions/AccountTransactions.reducer";
import AccountInfo from "./AccountInfo/AccountInfo.reducer";
import TokenHolders from "./TokenHolders/TokenHolders.reducer";
import Burn from "./Burn/Burn.reducer";
import TransactionInfo from "./TransactionInfo/TransactionInfo.reducer";
import ContractInfo from "./ContractInfo/ContractInfo.reducer";
import TokenInfo from "./TokenInfo/TokenInfo.reducer";
import Blocks from "./Blocks/Blocks.reducer";

const combinedReducers = combineReducers({
  Prices,
  GlobalStats,
  FoundationAddresses,
  TokenTransfers,
  TokenTransactions,
  AccountTransactions,
  AccountInfo,
  TokenHolders,
  Burn,
  TransactionInfo,
  ContractInfo,
  TokenInfo,
  Blocks,
});

const rootReducer = (state: any, action: any) => {
  return combinedReducers(state, action);
};

export default rootReducer;
